import { Order } from "../../clients/FirebaseClient/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthActions } from "./authSlice";
import { AppThunk } from "..";
import { defaultFirebaseClient } from "../../clients/FirebaseClient";

export const initialOrderState: Order[] = [];

const subscribeOrders = (): AppThunk => {
    return async (dispatch, getState): Promise<void> => {
        const uid = getState().auth.uid;
        if (!uid) {
            console.error("cannot subscribe to configuration of unknown user!");
            return;
        }
        return defaultFirebaseClient.subscribeToOrders(uid);
    };
};

export const orderSlice = createSlice({
    name: "orders",
    initialState: initialOrderState,
    reducers: {
        setOrders: (state, action: PayloadAction<Order[]>) => action.payload,
    },
    extraReducers: builder => {
        builder.addCase(AuthActions.unauthenticated, () => initialOrderState);
    },
});

export const OrderActions = {
    ...orderSlice.actions,
    subscribeOrders,
};
